module.exports = __webpack_public_path__ + "static/media/username_password.9d41281a.png";